import React from 'react'
import { injectIntl } from 'react-intl'
import Typography from '@material-ui/core/Typography'
import messages from './translate'

function DefaultApp(props) {
  const {
    intl: { formatMessage },
    currentApp,
  } = props

  return (
    <div className="module module-sales-dashboard">
      <div className="module-head">
        <Typography className="module-title" variant="h5">
          {currentApp.name}
        </Typography>
      </div>
      <div className="module-content">
        <h3>{formatMessage(messages.comingSoon)}</h3>
      </div>
    </div>
  )
}

export default injectIntl(DefaultApp)
